// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { forwardRef } from 'react';
import { cn } from '../lib/utils';

/**
 * Premium Input with enhanced focus ring (ring-offset-2, primary ring),
 * subtle background tint on hover, and smooth transitions.
 *
 * Used identically across OSS and Enterprise editions.
 */
const Input = forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-lg border border-input bg-background px-3 py-2',
          'text-[14px] text-foreground',
          'ring-offset-background transition-colors duration-150',
          'file:border-0 file:bg-transparent file:text-[14px] file:font-medium file:text-foreground',
          'placeholder:text-muted-foreground',
          'hover:bg-accent/30',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
